import {Component, EventEmitter, Input, Output, Renderer2} from '@angular/core';
import notify from 'devextreme/ui/notify';
import {take} from 'rxjs/operators';
import {OrdersService} from '../../services/orders.service';
import {RequisitionService} from '../../services/requisition.service';

@Component({
  selector: 'app-update-bill-to',
  templateUrl: './update-bill-to.component.html',
  styleUrls: ['./update-bill-to.component.scss'],
})
export class UpdateBillToComponent {
  @Input() public popupVisible = false;
  @Input() public from = 'order';
  @Input() public ids: number[] = [];
  @Output() public closeEvent = new EventEmitter();
  public isLoading = false;
  public selectedBillTo?: string;

  constructor(private renderer: Renderer2, private orderService: OrdersService, private requisitionService: RequisitionService) {
  }

  public close(): void {
    this.closeEvent.emit();
  }

  public save(): void {
    this.isLoading = true;
    const request = this.from === 'order' ? this.orderService.changeBillTo(this.selectedBillTo as string, this.ids) :
      this.requisitionService.changeBillTo(this.selectedBillTo as string, this.ids);

    request.pipe(take(1)).subscribe(() => {
      this.isLoading = false;
      notify('The bill to was updated successfully', 'success', 3000);
      this.closeEvent.emit();
    });
  }

  public billTypeChanged(billTo: any) {
    this.selectedBillTo = billTo;
  }

  public onTitleRendered(e: any) {
    const elements = (e.titleElement as HTMLElement).getElementsByClassName('dx-toolbar-items-container') as HTMLCollectionOf<HTMLElement>;
    if (elements) {
      if (elements.length > 0) {
        this.renderer.setStyle(elements.item(0), 'height', '54px');
      }
    }
  }
}
